import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { _HttpClient } from '../../net/http.client';
import { ApiService } from '../../net/apiRoute';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';

@Component({
  selector: 'app-select-tree',
  templateUrl: './app-select-tree.component.html',
  styleUrls: ['./app-select-tree.component.css'],
})
export class AppSelectTreeComponent implements OnInit {
  @Input() _url; // 请求地址
  @Input() Param: any; // 输入参数
  @Input() nzCheckable;
  @Output() Tree: EventEmitter<string> = new EventEmitter(); // 输出属性 菜单树
  nzShowSearch: boolean = true;
  nzCheckStrictly: boolean = false; // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
  nzDefaultExpandAll: boolean = true;
  nodes: any = [];

  constructor(private http: _HttpClient) { }

  ngOnInit(): void {
    if (this.nzCheckable == true) {
      this.nzCheckStrictly = true;
    }

    this.http.get(this._url, {}).subscribe((res: any) => {
      this.nodes = res.Result;
    });
  }
  //下拉项改变
  onChange(value): void {
    this.Tree.emit(value);
  }
}

